export const removeAllFalseValues = (values) => {
    return Object.fromEntries(Object.entries(values).filter(([_, v]) => !!v))
}